import { SVGProps } from "react";

const ChartBarIcon = ({ ...props }: SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M9 11.673V20.673M9 11.673H4.59961C4.03956 11.673 3.75981 11.673 3.5459 11.782C3.35774 11.8778 3.20487 12.0307 3.10899 12.2189C3 12.4328 3 12.713 3 13.2731V20.673H9M9 11.673V6.27307C9 5.71302 9 5.43278 9.10899 5.21887C9.20487 5.03071 9.35774 4.87784 9.5459 4.78197C9.75981 4.67297 10.0396 4.67297 10.5996 4.67297H13.3996C13.9597 4.67297 14.2403 4.67297 14.4542 4.78197C14.6423 4.87784 14.7948 5.03071 14.8906 5.21887C14.9996 5.43278 15 5.71302 15 6.27307V8.67297M9 20.673H15M15 20.673L21 20.6731V10.2731C21 9.71302 20.9996 9.43278 20.8906 9.21887C20.7948 9.03071 20.6429 8.87784 20.4548 8.78197C20.2409 8.67297 19.9601 8.67297 19.4 8.67297H15M15 20.673V8.67297"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ChartBarIcon;
